import { SlideZoomControls } from './slide_zoom_controls'

let lastSlideID = 0

export default class Slide {
  get defaultSrc () {
    if (!this.srcset) {
      return null
    }

    const srcs = this.srcset.split(',')
    const src = srcs[1] || srcs[0]
    return src.split(' ')[0]
  }

  constructor (data, number, options, errorCallback) {
    lastSlideID += 1

    this.id = lastSlideID
    this.srcset = data.img
    this.video = data.video
    this.title = data.title
    this.alt = data.alt
    this.subtitle = data.subtitle
    this.caption = data.caption
    this.number = number
    this.onErrorCallback = errorCallback
    this.options = options
  }

  copy () {
    return new Slide({
      img: this.srcset,
      video: this.video,
      title: this.title,
      alt: this.alt,
      subtitle: this.subtitle
    }, this.number, this.options, this.onErrorCallback)
  }

  assignPosition (position) {
    this.container.style.transform = `translateX(${position * 100}%)`
  }

  hide () {
    if (this.isBuilt) {
      this.container.style.transform = 'translateY(100%)'
    }
  }

  build (slidesContainer) {
    this.isBuilt = true
    this.container = document.createElement('div')
    this.container.className = 'media-slider__slide'
    this.container.dataset.number = this.number.toString()

    this.image = document.createElement('img')
    this.image.className = 'media-slider__image'

    if (this.options.linkTo) {
      const link = document.createElement('a')
      link.href = this.options.linkTo
      if (this.options.linkToTracking) {
        const tracking = JSON.parse(this.options.linkToTracking)

        link.dataset.interactionElement = tracking.interaction_element
        link.dataset.interactionSection = tracking.interaction_section
      }
      link.target = this.options.linkToTarget
      link.appendChild(this.image)
      this.container.appendChild(link)
    } else {
      this.container.appendChild(this.image)
    }

    this.load()

    this.buildImageSrc()

    if (this.title) {
      this.buildTitleOverlay()
    }

    if (this.video) {
      this.buildPlayButton()
    }

    if (this.caption) {
      this.buildCaption()
    }

    slidesContainer.appendChild(this.container)

    if (!this.options.cropImages) {
      this.displayFullImages()
    }

    if (this.options.enableZoomControls) {
      this.zoomControls = new SlideZoomControls(this.image)
    }
  }

  displayFullImages () {
    const ghostImage = this.image.cloneNode()
    ghostImage.classList.add('media-slider__image--ghost')
    this.image.classList.add('media-slider__image--contained')
    this.image.before(ghostImage)
  }

  buildPlayButton () {
    this.playButton = document.createElement('div')
    this.playButton.className = 'media-slider__play-button'

    this.container.appendChild(this.playButton)
  }

  buildTitleOverlay () {
    const overlayNode = document.createElement('div')
    const titleNode = document.createElement('div')
    const subtitleNode = document.createElement('div')

    overlayNode.className = 'media-slider__title-overlay'

    titleNode.className = 'media-slider__title-overlay-title'
    titleNode.innerHTML = this.title
    overlayNode.appendChild(titleNode)

    subtitleNode.className = 'media-slider__title-overlay-subtitle'
    subtitleNode.innerHTML = this.subtitle
    overlayNode.appendChild(subtitleNode)

    this.container.appendChild(overlayNode)
  }

  buildCaption () {
    const captionNode = document.createElement('div')
    const innerCaptionNode = document.createElement('div')
    captionNode.className = 'media-slider__caption'
    innerCaptionNode.className = 'media-slider__caption-inner'
    innerCaptionNode.textContent = this.caption
    captionNode.appendChild(innerCaptionNode)
    this.container.appendChild(captionNode)
  }

  buildImageSrc () {
    if (this.options.lazyLoadFirstImages && (this.number <= 2)) {
      this.image.loading = 'lazy'
    }

    this.image.srcset = this.srcset
    this.image.src = this.defaultSrc
    this.image.alt = this.alt || ''
  }

  load () {
    this.image.addEventListener('error', () => {
      this.errored = true

      if (this.onErrorCallback) this.onErrorCallback(this)
    })
  }

  // eslint-disable-next-line class-methods-use-this
  blur () { }
}
